import "./Blog.css";
import { NavBar, Footer } from "../../Components/ExportComponents";
// import facebook from "../../Photos/SocialIcons/Facebook.png";
// import linkind from "../../Photos/SocialIcons/Linkind.png";
// import pintrest from "../../Photos/SocialIcons/pintrest.png";
// import youtube from "../../Photos/SocialIcons/youtube.png";
import { Link } from "react-router-dom";
import { GetReady, Blog } from "../../Components/ExportComponents"
import { useParams } from "react-router-dom";

import develop from "../../Photos/webdevelopment.avif"
import courseIMG from "../../Photos/Courses/Courses1.png"

// Socail Image
import facebook from "../../Photos/Social Green/facebook.png";
import youtube from "../../Photos/Social Green/youtube.png";
import pintrest from "../../Photos/Social Green/pintrest.png";
import linkind from "../../Photos/Social Green/linkedin.png";

const BlogPage = ({ blogs, CoursesDetails }) => {
  // console.log(blogs[0].website)
  const { id } = useParams();



  // console.log(blogs)
  const blog = {
    title: "The Power of Visual Identity in Branding",
    tag: "Blog 1",
    content: [
      `Visual identity is the heart of a brand—it shapes how people see, feel, and remember a business. 
      From logos and colors to typography and design style, every visual element tells a story about the 
      brand's values and personality. A strong visual identity builds recognition, trust, and emotional 
      connection, helping a brand stand out in a crowded market.`,
      `Visual identity is the foundation of communication between brand and audience. Consistent use of 
      visual elements helps create a memorable and trustworthy image that resonates emotionally with 
      customers.`,
      `At ScaleUp Academy, we help brands design visual systems that reflect authenticity and purpose. 
      From logo creation to marketing strategy, every choice strengthens the brand's message.`
    ],
  };
  const singleblog = blogs.find(b => b.blogNo === parseInt(id));
  const singleBlogs = blogs.find(b => b.website.id === parseInt(id));
  // console.log(singleBlog)
  // const getCourse = CoursesDetails.find(b => b.name === singleblog.course);
  // console.log(getCourse)
  const singleBlog = singleBlogs.website;
  document.title = `Scaleup Academy | ${singleBlog.author.name} | ${singleBlog.catogery}`;

  // console.log(singleBlog.courses);
  // console.log(singleBlog.author.social[0].name)


  return (
    <>
      <NavBar color={true} />
      <div className="blog-container">
        <div className="blogIntro">
          <h1>{singleBlog.courseDesc.title}</h1>
          <div className="aboutUploader">
            <section>
              <div className="img">
                <img src={singleBlog.author.image} alt="Bhanu Dai" />
              </div>

              <div className="UploaderName">
                <p>{singleBlog.author.name}</p>
                <p>{singleBlog.author.alias}</p>
              </div>
              <span></span>
            </section>

            <section>
              <div className="texts">
                <p>{singleBlog.author.knowledge} </p>
              </div>
              <span></span>
            </section>

            <section>
              <div className="web">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={
                    singleBlog.author.site.startsWith("http")
                      ? singleBlog.author.site
                      : `https://${singleBlog.author.site}`
                  }
                >
                  {singleBlog.author.site}
                </a>
                <p>{singleBlog.author.email} </p>
              </div>
              <span />
            </section>

            <section>
              <div className="socialLinks">
                {/* {singleBlog.author.social.map((data, index) =>
                  <>
                    {data.name === "facebook" &&
                      <Link><img src={facebook} alt={singleBlog.author.name} /></Link>
                    }
                    {data.name === "youtube" &&
                      <Link><img src={youtube} alt={singleBlog.author.name} /></Link>
                    }
                    {data.name === "pintetrest" &&
                      <Link><img src={pintrest} alt={singleBlog.author.name} /></Link>
                    }
                  </>

                )} */}

                {/* <Link><img src={pintrest} alt={singleBlog.author.name} /></Link>
                <Link><img src={youtube} alt={singleBlog.author.name} /></Link> */}
              </div>
            </section>
          </div>
          <div className="line"></div>
          <div className="quickText">
            {2025}&nbsp;&nbsp;{singleBlog.author.alias}
          </div>
        </div>

        <div className="blogContent">
          <div className="titleBlog">
            Introduction
          </div>
          {singleBlog.introduction.content &&
            <div className="firstDesc">
              {singleBlog.introduction.content.map((txt, index) =>
                <p key={index}>{txt}</p>
              )}
            </div>
          }
          {singleBlog.courses.map((section, index) =>
            <>
              {section.sections.map((sec) =>
                <>

                  <div key={index} className="firstQuestion">
                    {sec.title}
                  </div>
                  <div key={index} className="firstAnswer">
                    {sec.content.map((content, i) =>
                      <p key={i}>{content}</p>
                    )}

                    <div className="firstQuestion">
                      {sec.lists.title}
                    </div>
                    <div className="listAnswer">
                      {sec.lists?.ul?.length > 1 && (
                        <ul>
                          {sec.lists.ul.map((txt, index) => (
                            <li key={index}>{txt}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                    <p>
                      {sec.lists.ending}
                    </p>

                  </div>


                </>
              )}
            </>

          )}
          {/* <div className="firstQuestion">
            {singleBlog.courses[0].title}
          </div> */}
          {/* <div className="firstAnswer">
            A full-stack developer works with both front-end (what users see) and
            back-end (the server, database, and logic) parts of an application. They use
            technologies like HTML, CSS, JavaScript, React, Node.js, Python, Django, and
            databases like MongoDB or MySQL to build complete web apps from start to
            finish.
          </div>

          <div className="secondQuestion">
            Why Full-Stack Developers Are in High Demand
          </div>
          <div className="listAnswer">
            <ul>
              <li>
                <strong>They Can Do It All:</strong> Companies like to hire people who
                understand the whole system. Instead of depending on different teams, they
                prefer one developer who can manage both design and logic.
              </li>
              <li>
                <strong>Perfect for Startups:</strong> Startups usually don’t have big
                teams. Full-stack developers help them build products faster and with less
                cost, which makes them very valuable.
              </li>
              <li>
                <strong>Digital Growth Everywhere:</strong> From hospitals to schools,
                every field is going digital. That means more websites, web apps, and
                online services — and more need for developers who can handle complete
                projects.
              </li>
              <li>
                <strong>Global and Remote Work:</strong> Developers from anywhere can work
                for companies around the world. Whether you’re from Nepal, India, or
                anywhere else, full-stack skills open global job opportunities.
              </li>
              <li>
                <strong>Future Technologies:</strong> Full-stack development is also
                connecting with AI, cloud computing, and cybersecurity. Learning these
                together makes a developer stand out from the crowd.
              </li>
            </ul>
          </div>

          <div className="simpleTextQ">
            Skills That Are in Demand
          </div>
          <div className="listAnswer">
            <ul>
              <li>
                <strong>They Can Do It All:</strong> Companies like to hire people who
                understand the whole system. Instead of depending on different teams, they
                prefer one developer who can manage both design and logic.
              </li>
              <li>
                <strong>Perfect for Startups:</strong> Startups usually don’t have big
                teams. Full-stack developers help them build products faster and with less
                cost, which makes them very valuable.
              </li>
              <li>
                <strong>Digital Growth Everywhere:</strong> From hospitals to schools,
                every field is going digital. That means more websites, web apps, and
                online services — and more need for developers who can handle complete
                projects.
              </li>
              <li>
                <strong>Global and Remote Work:</strong> Developers from anywhere can work
                for companies around the world. Whether you’re from Nepal, India, or
                anywhere else, full-stack skills open global job opportunities.
              </li>
              <li>
                <strong>Future Technologies:</strong> Full-stack development is also
                connecting with AI, cloud computing, and cybersecurity. Learning these
                together makes a developer stand out from the crowd.
              </li>
            </ul>
          </div> */}


          {/* <div className="lastTextH1">
            Final Thoughts
          </div>
          <div className="simpleText">
            The demand for full-stack developers is growing every single day. It’s not
            just a career — it’s a path that gives you freedom, creativity, and global
            opportunities. I believe that being a full-stack developer in today’s world
            means having the power to turn ideas into real products that people use
            every day.
          </div>

          <div className="blogOutro">
            If you’re learning full-stack development right now, keep going. The world
            really needs more builders and creators like us.
          </div> */}

        </div>

        <div className="courseIntro">
          <div className="tags">
            <p className="active">Graphic Design</p>

            <p>Ui/Ux Design</p>
            <p>Logo design</p>
            <p>Branding</p>
            <p>Typography</p>
            <p>Colors</p>
            <p>3D</p>
            <p>Pattern</p>
          </div>


          {/* {getCourse &&
            <>
              <div className="courseBoxPreview">
                <div className="image">
                  <img src={getCourse.crs} alt="logo" />
                </div>
                <div className="crcDesc">
                  <p>{getCourse.name}</p>
                  <div className="descCrc">
                    <p>{getCourse.for}</p>
                    <p>The Ultimate Graphic Design Course Which Covers Photoshop, Illustrator,<br /> InDesign, Design Theory, Branding, Logo Design </p>
                  </div>
                  <div className="crcTag">
                    {getCourse.type.map((txt, index) =>
                      <p id={index}>{txt}</p>
                    )}

                  </div>

                  <div className="courseTeacher">
                    <img src={getCourse.teacher} alt="Bhanu Dai" />
                    <div className="UploaderName">
                      <p>{getCourse.teacherName}</p>
                      <p>{getCourse.tagName} </p>
                    </div>
                  </div>
                  <Link className="linkCourseTo">Learn more</Link>
                </div>
              </div>
            </>
          } */}

        </div>

      </div>
      <Blog white="whiteBack" Blogs={blogs} />
      <GetReady clean={true} back={"whiteBack"} />
      <Footer />
    </>
  );
};

export default BlogPage;
